import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTopUpIcon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.913 5.91304C12.913 5.40878 12.5043 5 12 5C11.4957 5 11.087 5.40878 11.087 5.91304V11.087H5.91304C5.40878 11.087 5 11.4957 5 12C5 12.5043 5.40878 12.913 5.91304 12.913H11.087V18.087C11.087 18.5912 11.4957 19 12 19C12.5043 19 12.913 18.5912 12.913 18.087V12.913H18.087C18.5912 12.913 19 12.5043 19 12C19 11.4957 18.5912 11.087 18.087 11.087H12.913V5.91304Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgTopUpIcon);
export default ForwardRef;
